import {Component, Input} from '@angular/core';
import {SupportFormService} from '../../../services';

@Component({
  selector: 'dcp-contact-us-button',
  templateUrl: './contact-us-button.component.html',
  styleUrls: ['./contact-us-button.component.scss'],
  standalone: false,
})
export class ContactUsButtonComponent {
  @Input() isButton: boolean = true;
  @Input() buttonText: string = 'configurator.error.contactUs.buttonText';
  @Input() linkParams?: string;
  @Input() errorMessage?: string;
  isContactModalOpen: boolean = false;

  constructor(protected supportFormService: SupportFormService) {}

  contactSupport() {
    this.supportFormService.open(this.errorMessage);
  }
}
